import { render, staticRenderFns } from "./BankTransferCard.vue?vue&type=template&id=8321aee0&scoped=true&"
import script from "./BankTransferCard.vue?vue&type=script&lang=js&"
export * from "./BankTransferCard.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferCard.vue?vue&type=style&index=0&id=8321aee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8321aee0",
  null
  
)

export default component.exports